import React, { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { AutocompleteControl } from 'components/_basic/Form/Autocomplete/AutocompleteControl/AutocompleteControl';
import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';
import { DELIVERY_TERMS_OPTIONS_DEU } from 'components/BusinessToolForm/constants/deu/options_deu';
import { DELIVERY_TERMS_OPTIONS_ES } from 'components/BusinessToolForm/constants/es/options_es';
import { DELIVERY_TERMS_OPTIONS } from 'components/BusinessToolForm/constants/options';
import { DELIVERY_TERMS_OPTIONS_UA } from 'components/BusinessToolForm/constants/ua/options_ua';

import { concatWithDot } from 'helpers/string';

import { KEY_SUPPLIERS_CHARACTERIZE } from '../utils/form';

export const KeySuppliers: React.FC<{ name: string; disabled?: boolean }> = memo(({ name, disabled }) => {
  const { t, i18n } = useTranslation();
  const { control } = useFormContext();

  const getChosenOptions = (lang: string) => {
    switch (lang) {
      case 'de':
        return DELIVERY_TERMS_OPTIONS_DEU;

      case 'uk':
        return DELIVERY_TERMS_OPTIONS_UA;
      case 'es':
        return DELIVERY_TERMS_OPTIONS_ES;

      default:
        return DELIVERY_TERMS_OPTIONS;
    }
  };

  return (
    <BorderedCard>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextInputControl
                control={control}
                id={concatWithDot(name, KEY_SUPPLIERS_CHARACTERIZE.NAME)}
                name={concatWithDot(name, KEY_SUPPLIERS_CHARACTERIZE.NAME)}
                label={t('businessOperations.partners.keySuppliers.name')}
                disabled={disabled}
                maxLength={150}
              />
            </Grid>
            <Grid item xs={4}>
              <TextInputControl
                control={control}
                id={concatWithDot(name, KEY_SUPPLIERS_CHARACTERIZE.PRODUCT)}
                name={concatWithDot(name, KEY_SUPPLIERS_CHARACTERIZE.PRODUCT)}
                label={t('businessOperations.partners.keySuppliers.product')}
                disabled={disabled}
                maxLength={150}
              />
            </Grid>
            <Grid item xs={4}>
              <TextInputControl
                control={control}
                id={concatWithDot(name, KEY_SUPPLIERS_CHARACTERIZE.QUANTITY)}
                name={concatWithDot(name, KEY_SUPPLIERS_CHARACTERIZE.QUANTITY)}
                label={t('businessOperations.partners.keySuppliers.quantity')}
                disabled={disabled}
                maxLength={150}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <NumberInputControlled
                control={control}
                id={concatWithDot(name, KEY_SUPPLIERS_CHARACTERIZE.PRICE)}
                name={concatWithDot(name, KEY_SUPPLIERS_CHARACTERIZE.PRICE)}
                label={t('businessOperations.partners.keySuppliers.price')}
                adornmentType="currency"
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={4}>
              <AutocompleteControl
                control={control}
                options={getChosenOptions(i18n.language)}
                defaultValue={getChosenOptions(i18n.language)[0].value}
                id={concatWithDot(name, KEY_SUPPLIERS_CHARACTERIZE.DELIVERY_TERMS)}
                name={concatWithDot(name, KEY_SUPPLIERS_CHARACTERIZE.DELIVERY_TERMS)}
                label={t('businessOperations.partners.keySuppliers.deliveryTerms')}
                disabled={disabled}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </BorderedCard>
  );
});
